<div class="editor">
  
  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>
  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
      <app-text-format-config
      [device]="device"
      [objectChoosing]="objectChoosing"
      [class]="class"
      [config]="config"
      
      [staticdata]="staticdata"
      [textContentClass]="class['text-brand__content']"
      [textWrapperClass]="class['text-brand__wrapper']"
      >
</app-text-format-config>
    <div class="config-name">
      <p>{{'xuong_dong' | translate}}</p>
      <nz-switch [ngModel]="class['text-brand__wrapper']['white-space'] && class['text-brand__wrapper']['white-space'] !== 'nowrap'"
      (ngModelChange)="class['text-brand__wrapper']['white-space'] = $event ? 'pre-wrap' : 'nowrap';updateClass()"></nz-switch>
    </div>
    </div>
  </ng-container>
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{currentViewAll.title | translate}}</span>
  </div>
  <ng-container *ngIf="!isViewAll && configMode == 'advanced'">
    <ul nz-menu nzMode="inline">
      <!-- Cấu hình tái sử dụng thiết kế-->
      
      <!-- CHỮ VÀ ĐỊNH DẠNG -->
      <li nz-submenu nzTitle="{{'chu_va_dinh_dang' | translate}}" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
        <div class="editor-field">
          <div class="editor-field-body">
            <!-- Lựa chọn hiển thị cho các thiết bị -->
            <app-hide-show-config
                    [device]="device"
                    [elementChoosing]="objectChoosing">
            </app-hide-show-config>

            <app-text-format-config
                    [device]="device"
                    [objectChoosing]="objectChoosing"
                    [class]="class"
                    [config]="config"
                    
                    [staticdata]="staticdata"
                    [textContentClass]="class['text-brand__content']"
                    [textWrapperClass]="class['text-brand__wrapper']"
                    >
            </app-text-format-config>
            <div class="config-name">
              <p>{{'xuong_dong' | translate}}</p>
              <nz-switch [ngModel]="class['text-brand__wrapper']['white-space'] && class['text-brand__wrapper']['white-space'] !== 'nowrap'"
              (ngModelChange)="class['text-brand__wrapper']['white-space'] = $event ? 'pre-wrap' : 'nowrap';updateClass()"></nz-switch>
            </div>
            <div class="field-row">
              <div class="config-font" style="margin-top:20px">
                <!-- Khoảng cách chữ -->
                <div class="font-text-letterspacing">
                  <div class="config-name" style="gap:5px">
                    <p class="m-0" style="line-height:1.5">{{'khoang_cach_chu' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="50" [ngStyle]="{ width: '40%' }"
                      [ngModel]="class['text-brand__content']['letter-spacing'] | vhnumber" (nzBlur)="updateClass()"
                      (ngModelChange)="class['text-brand__content']['letter-spacing'] = $event +'px'">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="0" [nzMax]="50"
                        [ngModel]="class['text-brand__content']['letter-spacing'] | vhnumber"
                        (nzOnAfterChange)="updateClass();"
                        (ngModelChange)="class['text-brand__content']['letter-spacing'] = $event +'px'">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </div>
                <!-- Khoảng cách dòng -->
                <div class="font-text-linespacing">
                  <div class="config-name">
                    <p class="m-0" style="line-height:1.5">{{'khoang_cach_dong' | translate}}</p>
                    <nz-input-number [ngStyle]="{ width: '40%' }"
                      [(ngModel)]="this.class['text-brand__content']['line-height']" (nzBlur)="updateClass()"
                      [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1"
                        [(ngModel)]="this.class['text-brand__content']['line-height']"
                        (nzOnAfterChange)="updateClass()">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
      <!-- PHONG CÁCH -->
      <li nz-submenu nzTitle="{{'phong_cach_va_kieu_co' | translate}}" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
        <app-text-style-config
                [config]="config"
                [class]="class"
                [staticdata]="staticdata"
                [device]="device"
                [objectChoosing]="objectChoosing"
                [textContentClass]="class['text-brand__content']"
                [textWrapperClass]="class['text-brand']"
                [filterConfig]="config['text-shadow']"
                [isShape]="false"
        >
        </app-text-style-config>
      </li>
      <!-- Cấu hình xoay-->
      <li nz-submenu nzTitle="{{'cau_hinh_xoay' | translate}}" [(nzOpen)]="openMap.menu9"
        (nzOpenChange)="openHandler('menu9')">
        <app-rotate-config [classRotate]="class['text-brand']" [config]="config" [device]="device"
          [objectChoosing]="objectChoosing"></app-rotate-config>
      </li>
      <!-- Cấu hình khoảng đệm-->
      <li nz-submenu nzTitle="{{'khoang_dem' | translate}}" [(nzOpen)]="openMap.menu11"
        (nzOpenChange)="openHandler('menu11')">
        <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
          [classPadding]="class['text-brand__content']" [paddingConfigs]="[
          { type: 'top' },
          { type: 'bottom' },
          { type: 'left' },
          { type: 'right' },
        ]">
        </app-padding-config>
      </li>
      <!-- Cấu hình viền-->
      <li nz-submenu nzTitle="{{'vien' | translate}}" [(nzOpen)]="openMap.menu12"
        (nzOpenChange)="openHandler('menu12')">
        <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
          [borderClass]="class['text-brand__content']" [id_object]="objectChoosing._id">
        </app-borders-config>

        <!-- Nút mở rộng -->
        <div class="item-border my-3" style="float: right">
          <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[1])">
            {{'bo_goc' | translate}} &#8594;
          </p>
        </div>
      </li>
      <!-- HIỆU ỨNG -->
      <li nz-submenu nzTitle="{{'hieu_ung' | translate}}" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
        <app-choose-animations-config [type]="type" [elementChoosing]="objectChoosing" (openAnimationDetail)="openAnimationDetail($event)"
          [id_object]="objectChoosing._id" [device]="device" [class]="class" [config]="config" [staticdata]="staticdata"
          [cursorClass]="class['text-brand']" [effect_hover]="effect_hover" [customize]="customize" [effectFileUsing]="'text'">
        </app-choose-animations-config>
      </li>
      <!-- THÊM LIÊN KẾT -->
      <li  nz-submenu nzTitle="{{'lien_ket' | translate}}" [(nzOpen)]="openMap.menu6"
        (nzOpenChange)="openHandler('menu6')">
        <app-link-page-config 
          [objectChoosing]="objectChoosing" 
          [staticdata]="staticdata" 
          [id_object]="objectChoosing._id" 
          [dynamic_data]="objectChoosing.dynamic_data" 
          [type_page]="['detail_category']"
        >
        </app-link-page-config>
      </li>
    </ul>
  </ng-container>

  <!-- CẤU HÌNH CHI TIẾT -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="config['animation-selected'].id != '000000' && currentViewAll.index == 1">
       <app-animations-config [type]="type" [elementChoosing]="objectChoosing" [device]="device" [staticdata]="staticdata" [id_object]="objectChoosing._id"
        [customize]="customize"></app-animations-config>
    </div>
    <!-- Cấu hình chi tiết viền -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 2">
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
        [borderRadiusClass]="class['text-brand__content']" [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>
  </div>
</div>